// extracted by mini-css-extract-plugin
export var container = "styles-module__container___eAvOo";
export var trayContent = "styles-module__trayContent___LYd3q";
export var headline = "styles-module__headline___qTxty";
export var button = "styles-module__button___i8omj";
export var buttonContainer = "styles-module__buttonContainer___qnqTx";
export var spacer = "styles-module__spacer___u9ew2";